module.exports = __webpack_public_path__ + "img/xinhuashe.cb520b3b.png";